import type { Moment } from 'moment'
import type { ComponentProps } from 'react'
import React, { useContext } from 'react'
import { useIntl } from 'react-intl'

import TextButton from 'LuxKit/Button/TextButton'
import ModalContext from 'contexts/ModalContext'
import MoreOffersModal from 'tripPlanner/components/TripModal/ViewMoreOffers/MoreOffersModal'

interface Props {
  offerId?: string
  checkIn?: Moment
  checkOut?: Moment
  tripId: string
  sectionId: string
  className?: string
  showSearch: boolean
  size?: ComponentProps<typeof TextButton>['size']
}

function ViewMoreOffersCta({
  offerId,
  checkIn,
  checkOut,
  sectionId,
  tripId,
  className,
  showSearch,
  size = 'medium',
}: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  return (
    <TextButton
      kind="secondary"
      size={size}
      className={className}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        showModal(
          <MoreOffersModal
            tripId={tripId}
            sectionId={sectionId}
            offerId={offerId}
            checkIn={checkIn}
            checkOut={checkOut}
            showSearch={showSearch}
          />,
        )
      }}
    >
      {intl.formatMessage({
        id: '5Zj0d-7dPFwoanmfQ_FE',
        defaultMessage: 'View more offers',
        description: 'Button to view additional accommodation offers for a trip item',
      })}
    </TextButton>
  )
}

export default ViewMoreOffersCta
